import React, { Component } from 'react';
import { isBrowser } from 'react-device-detect';
import Heading from "../elements/Heading";
import globals from '../globals';

class Table extends Component {

    constructor(props) {
        super(props);

        this.state = {
            title: '',
            subTitle: '',
            leadCopy: [],
            table: {
                headings: [],
                rows: []
            }
        };
    }

    componentDidMount() {
        this.setState(this.props.data);
        this.controller = globals.genericAnimation(this);
    }

    componentDidUpdate(prevProps) {
        if (prevProps !== this.props) {
            this.setState(this.props.data);
        }
    }

    componentWillUnmount() {
        globals.destroy(this.controller);
    }
    
    render() {
        const LeadCopy = this.state.leadCopy.map((item, key) => {
            return (
                <p key={key}>{item}</p>
            );
        });

        const Headings = this.state.table.headings.map((heading, key) => {
            return (
                <div key={key}>
                    {heading}
                </div>
            );
        });

        const Rows = this.state.table.rows.map((rows, key) => {
            const InnerRows = rows.map((innerRow, innerKey) => {
                return (
                    <div key={innerKey} dangerouslySetInnerHTML={{__html: innerRow}} />
                );
            });

            return (
                <div key={key} className="flex-row">
                    {InnerRows}
                </div>
            );
        });
        
        return (
            <div className="table-section">
                {(this.props.image && isBrowser ? <img src={this.props.image} alt="" /> : '')}
                <div className="row centered">
                    <div className={(this.props.fullWidth ? 'col-xs-12' : 'col-md-8 col-md-offset-2 col-xs-12')}>
                        {(this.state.title.length > 0 ? <Heading title={this.state.title} subTitle={this.state.subTitle} /> : '')}
                        {(this.state.leadCopy.length > 0 ? LeadCopy : '')}
                        <div className="table-container">
                            <div className="flex-row headings">
                                {Headings}
                            </div>
                            {Rows}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    
}

export default Table;


// WEBPACK FOOTER //
// ./resources/assets/js/modules/Table.js